import { OpenAPI } from '../api/core/OpenAPI';
import { store } from '../redux/store';
import type { PendingWorkResponse } from '../types/pendingWork.types';

/**
 * Actionable pending-work inbox for Inicio.
 * `scope`: "global" or a numeric location id (same as other dashboard endpoints).
 */
export async function fetchPendingWork(
  scope?: string,
  signal?: AbortSignal,
): Promise<PendingWorkResponse> {
  const apiBaseUrl = OpenAPI.BASE;
  const token = store.getState().auth.token ?? '';

  if (token === '') {
    throw new Error('No se encontró token de autenticación.');
  }

  const url = new URL(`${apiBaseUrl}/dashboard/pending-work`);
  if (scope != null && scope !== '') {
    url.searchParams.set('scope', scope);
  }

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    signal,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({
      message: 'Error desconocido',
    }));
    throw new Error(
      (errorData as { message?: string }).message ??
        `Error ${response.status}: ${response.statusText}`,
    );
  }

  const data = (await response.json()) as PendingWorkResponse;
  return {
    total: Number(data?.total ?? 0),
    records: data?.records == null ? null : Number(data.records),
    transfers: data?.transfers == null ? null : Number(data.transfers),
    requests: data?.requests == null ? null : Number(data.requests),
    salesPendingPayment:
      data?.salesPendingPayment == null ? null : Number(data.salesPendingPayment),
  };
}
